<template>
  <v-layout row wrap class="folder-status-cards-container">
    <v-flex xs12 sm6 md3 class="pa-2">
      <v-card
        class="custom-card total mb-2"
        flat
        color="grey lighten-3"
        height="90"
      >
        <v-card-title class="pb-0 custom-title"><span class="mt-1">{{ totalLabel }}</span> </v-card-title>
        <v-card-text class="pt-0">
          <strong class="amount">{{ counts.total || folders.length }}</strong>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm6 md3 class="pa-2">
      <v-card
        class="custom-card received mb-2 d-flex"
        flat
        height="90"
      >
        <div class="flex-column">
          <v-card-title class="pb-0 custom-title">
            RECEBIDOS
          </v-card-title>
          <v-card-text class="pt-0">
            <strong class="amount">{{ counts.received || getLocalCount('Recebido') }}</strong>
          </v-card-text>
        </div>
        <div class="d-inline-flex">
          <v-icon medium class="green--text text--lighten-1">mdi-check</v-icon>
        </div>
      </v-card>
    </v-flex>
    <v-flex xs12 sm6 md3 class="pa-2">
      <v-card
        class="custom-card refused mb-2 d-flex"
        flat
        height="90"
      >
        <div class="flex-column align-center">
          <v-card-title class="pb-0 custom-title">
            RECUSADOS
          </v-card-title>
          <v-card-text class="pt-0">
            <strong class="amount">{{ counts.refused || getLocalCount('Recusado') }}</strong>
          </v-card-text>
        </div>
        <div class="d-inline-flex align-center">
          <v-icon medium class="red--text text--lighten-2">mdi-rotate-left</v-icon>
        </div>
      </v-card>
    </v-flex>
    <v-flex xs12 sm6 md3 class="pa-2">
      <v-card
        class="custom-card waiting mb-2 d-flex"
        flat
        height="90"
      >
        <div class="flex-column align-center">
          <v-card-title class="pb-0 custom-title">
            AGUARDANDO
          </v-card-title>
          <v-card-text class="pt-0">
            <strong class="amount">{{ counts.waiting || getLocalCount('Não Recebido') }}</strong>
          </v-card-text>
        </div>

        <div class="d-inline-flex">
          <v-icon medium class="orange--text text--lighten-2">mdi-clock-outline</v-icon>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'FolderStatusCards',
  props: {
    folders: {
      type: Array,
      default: () => []
    },
    counts: {
      type: Object,
      default: () => ({})
    },
    context: {
      type: String,
      default: 'inbox',
      validator: value => ['inbox', 'sent', 'unreceived'].includes(value)
    }
  },
  computed: {
    totalLabel() {
      const labels = {
        sent: 'TOTAL DE ENVIOS',
        inbox: 'TOTAL NA CAIXA',
        unreceived: 'TOTAL NÃO RECEBIDOS'
      };
      return labels[this.context] || 'TOTAL';
    }
  },
  methods: {
    getLocalCount(status) {
      // Fallback para contagem local se não vier do backend
      return this.folders.filter(folder => {
        // Usar a mesma lógica do FolderCard.vue
        return folder.received_status === status;
      }).length;
    }
  }
};
</script>

<style scoped lang="scss">
.folder-status-cards-container {
  margin: 14px 0;
}

.custom-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  }

  .custom-title {
    font-size: 0.875rem;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: #616161;
    display: flex;
    align-items: center;

    v-icon {
      color: inherit;
    }
  }

  .amount {
    font-size: 1.75rem;
    font-weight: 700;
    color: #424242;
    //display: block;
    //margin-top: 4px;
  }

  &.total {
    background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%) !important;

    .amount {
      color: #424242;
    }
  }

  &.received {
    background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%) !important;

    .amount, .custom-title {
      color: #2e7d32;
    }
  }

  &.refused {
    background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%) !important;

    .amount, .custom-title {
      color: #c62828;
    }
  }

  &.waiting {
    background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%) !important;

    .amount, .custom-title {
      color: #ef6c00;
    }
  }
}

@media (max-width: 600px) {
  .custom-card {
    .custom-title {
      font-size: 0.75rem;
    }

    .amount {
      font-size: 1.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/folder/FolderStatusCards.vue